import {Component} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../globals';
import {CommonModule} from '@angular/common';
import {FormService} from '../services/FormService';
import {Checkbox} from 'primeng/checkbox';

declare var Yii: IYii;

@Component({
  selector: 'ng-form-pdf',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Checkbox
  ],
  template: `
    <div class="form-row">
      <label>
        {{ Yii.t('be_forms', 'Digitally Sign on Submit') }}
      </label>
      <div>
        <p-checkbox
          [(ngModel)]="nfsvc.form.digitallySignOnSubmit"
          binary="true"
        />
      </div>
    </div>
    <div class="form-row">
      <label>
        {{ Yii.t('be_forms', 'Attach PDF to Email') }}
      </label>
      <div>
        <p-checkbox
          [(ngModel)]="nfsvc.form.attachPdfToEmail"
          binary="true"
        />
      </div>
    </div>

    @if (!nfsvc.form.isHTMLForm) {
      <div class="form-row">
        <label>
          {{ Yii.t('be_forms', 'Add reference number') }}
        </label>
        <div>
          <p-checkbox
            [(ngModel)]="nfsvc.form.showReferenceNumber"
            binary="true"
          />
        </div>
      </div>
    }
  `
})
export class FormPDFComponent {
  Yii = Yii;

  constructor(public nfsvc: FormService) {
  }
}
